import { useMutation } from "react-query";
import { queryClient } from "../../../../utils/query-client";
import { usersQueries, useUsersService } from "../../../../services/userService";

export function useDeleteUserModalHook({onClose, selectedUser}){
    const assetService = useUsersService();

    const { mutate, isLoading } = useMutation((payload) => assetService.deleteUsers({id : selectedUser.id, onSuccess}));

    function onSuccess() {
        queryClient.refetchQueries(usersQueries.GET_ALL);
        onClose();
    }

    function onSubmit() {
        mutate();
    }

    return{
        form: {
            onSubmit,
            isLoading
        }
    }
}